import { DestroyRef, Directive, OnInit, inject, input, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl, FormGroup } from '@angular/forms';
import { FilterTitles, filterList } from './filter-options-helper';

@Directive()
export class BaseFilterComponent implements OnInit {
  filtersForm = input<FormGroup>();
  controlName = input<string>();
  lmtFrom = input<string>();
  lmtTo = input<string>();
  utcFrom = input<string>();
  utcTo = input<string>();
  recentValue = input<string>();
  recentUnit = input<string>();
  filterEnableControl = input<string>();
  pageName = input<string>();
  icon = input<string>();
  svgIcon = input<string>();
  title = input<string>();
  isLocalTimeFilterVisible = input(true);
  control: AbstractControl;

  isFilterHidden = signal(false);

  filterList = filterList;
  FilterTitles = FilterTitles;

  destroyRef = inject(DestroyRef);

  ngOnInit() {
    this.control = this.filtersForm()?.get(this.filterEnableControl());
    if (this.control) {
      this.isFilterHidden.set(this.control.value);
      this.control.valueChanges.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((value) => {
        // hide filter control on reset button click
        if (value === null) {
          this.isFilterHidden.set(false);
        }
      });
    }
  }

  toggleShowFilter() {
    this.isFilterHidden.update((pre) => !pre);
    this.control.setValue(this.isFilterHidden());
  }
}
